import React from "react";
import { NavLink } from "react-router-dom";
import featPBanner from "../../assets/images/key-features/featurePBanner.png";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import intelligentLead from "../../assets/images/key-features/IL_M.svg";
import advanceReporting from "../../assets/images/key-features/AR_A.svg";
import automatedEmail from "../../assets/images/key-features/AE_S.svg";
import contactIntelliAi from "../../assets/images/key-features/contact-intelli.svg"
import dataEnrich from "../../assets/images/key-features/DE_M.svg";
import multiChannelMngt from "../../assets/images/key-features/MCCM.svg";
import realTimeActivity from "../../assets/images/key-features/real-time-activity.svg"
import smartLeadMng from "../../assets/images/key-features/smart-lead.svg"
import aipoweredsalestrig from "../../assets/images/key-features/ai-powered-sales.svg"
import seamlessInte from "../../assets/images/key-features/SI.svg";
import Cta from "../../components/cta/cta";
import Testimonials from "../../components/home/Testimonials";

const Feature = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";
  const customGap24 = "24px";
  return (
    <>
      <div className="features-main-wrapper">
        <section className="feat-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb20 text-color-131415">
                    Features That <br /> Transform Your <br />{" "}
                    <span
                      className="text-primary-color"
                      style={{ fontStyle: "italic" }}
                    >
                      Business
                    </span>
                  </h1>
                  <p className="heading16px roboto-regular mb30">
                    Empower your sales, marketing, and financial <br />{" "}
                    strategies with advanced CRM and automation tools.
                  </p>

                  <ul className="btn-sec">
                    <li>
                      <NavLink
                        to={"/signup"}
                        className="common-btn-class main-btn-primary roboto-regular"
                      >
                        {" "}
                        Get Started
                      </NavLink>
                    </li>
                  </ul>
                </div>
                <div>
                  <img
                    src={featPBanner}
                    className="img-responsive position-relative"
                    alt="Automate the Boring Stuff, Close the Fun Deals"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="homeServices-wrapper _border-top">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 text-center heading29px">
                Features That’ll Make You Go WOW!
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridTemplateColumns,
                  "--grid-gap": customGap24,
                }}
              >
                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={intelligentLead}
                    alt="Hospitality-Centric Lead Management"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Hospitality-Centric Lead Management
                  </h3>
                  <p className="heading16px roboto-regular">
                    Capture and manage corporate bookings, event inquiries, and travel agent leads efficiently.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={advanceReporting}
                    alt="Reputation Management with AI Intelligence"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Reputation Management with AI Intelligence
                  </h3>
                  <p className="heading16px roboto-regular">
                    Monitor and respond to reviews across platforms like TripAdvisor, Google, and OTA channels.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={automatedEmail}
                    alt="Email & WhatsApp Sequencing"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Email & WhatsApp Sequencing
                  </h3>
                  <p className="heading16px roboto-regular">
                    Automate follow-ups for group bookings, loyalty programs, and promotional offers
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={contactIntelliAi}
                    alt="Contact Intelligence + AI Enrichment"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Contact Intelligence + AI Enrichment
                  </h3>
                  <p className="heading16px roboto-regular">
                    Access detailed profiles of travel agencies, event planners, and corporate clients.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={dataEnrich}
                    alt="Automated Outreach with Generative AI"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Automated Outreach with Generative AI
                  </h3>
                  <p className="heading16px roboto-regular">
                    Create personalized email and WhatsApp campaigns for follow-ups, offers, and loyalty with AI content suggestions
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={multiChannelMngt}
                    alt="Multi-Property Campaign Management"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Multi-Property Campaign Management
                  </h3>
                  <p className="heading16px roboto-regular">
                    Run centralized campaigns across hotel chains or multiple locations
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={aipoweredsalestrig}
                    alt="AI powered Sales Trigger"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    AI powered Sales Trigger
                  </h3>
                  <p className="heading16px roboto-regular">
                    Get notified when target accounts show interest in similar venues, events, or hospitality services
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={seamlessInte}
                    alt="CRM & PMS Integration"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    CRM & PMS Integration
                  </h3>
                  <p className="heading16px roboto-regular">
                    Connect seamlessly with hotel CRMs and Property Management Systems for unified operations.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={smartLeadMng}
                    alt="Smart Lead Management for Hospitality"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Smart Lead Management for Hospitality
                  </h3>
                  <p className="heading16px roboto-regular">
                    Customizable forms for event RFPs, corporate bookings, and dining reservations.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={realTimeActivity}
                    alt="Real-Time Activity Timeline"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Real-Time Activity Timeline
                  </h3>
                  <p className="heading16px roboto-regular">
                    Track all guest and prospect touchpoints—from the first inquiry to post-stay feedback.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Ready to experience the difference?"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default Feature;
